<app-list-header
  [title]="title"
  [searchable]="false"
  [addable]="false"
  [closable]="!!choiceEvent.topic"
></app-list-header>

<div class="table-container">
  <table class="table">
    <thead>
      <tr>
        <th class="name-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let action of actions | async"
        (click)="select(action)"
        [class.selected]="action === selectedAction"
        [style.--action-color]="getColorForAction(action)"
      >
        <td>
          <span class="action-icon">
            <mat-icon>{{ getIconForAction(action) }}</mat-icon>
          </span>
          {{ getDisplayLabel(action) }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
